<template>
  <div>
    <base-card v-if="item == 10">
      <v-card-text>
        <v-card-text>
          <div class="mb-5"><span class="text-h6">Company Setting</span></div>

          <v-switch
            v-model="allowIngredient"
            label="Ingredient Features"
            :true-value="1"
            :false-value="0"
            @change="updateCompanyIngredientOption"
          />
        </v-card-text>
      </v-card-text>
    </base-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { BASEURL } from "@/api/baseurl";
import axios from "axios";

export default {
  props: {
    item: {
      type: Number,
      default: "",
    },
  },

  data: () => ({
    domain: BASEURL,
    show: false,
    snackbar: false,
    text: "",
    snackbarColor: "",
    timeout: 1900,
    allowIngredient: 0,
    companyID: "",
  }),

  computed: {},

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyDetail()
  },
  methods: {
    getCompanyDetail() {
      const params = new URLSearchParams();
      params.append("getCompanyDetail", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/company/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var data = response.data.company
            this.allowIngredient = data[0].allow_ingredient
            // this.text = "Successfully edit";
            // this.snackbar = true;
            // this.snackbarColor = "success";
            
          } 
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateCompanyIngredientOption(){
      const params = new URLSearchParams();
      params.append("updateCompanyIngredientOption", "done");
      params.append("company_id", this.companyID);
      params.append("allow_ingredient", this.allowIngredient);

      axios({
        method: "post",
        url: this.domain + "/company/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.text = "Successfully update";
            this.snackbar = true;
            this.snackbarColor = "success";
            this.$root.$emit('refresh-sidebar')
          }else{
            this.text = "Try again. Something went wrong";
            this.snackbar = true;
            this.snackbarColor = "error";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>